import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';
import DashboardChart from './DashboardChart';

interface HeroProps {
  user?: any;
}

const Hero: React.FC<HeroProps> = ({ user }) => {
  const [isComponentReady, setIsComponentReady] = useState(false);

  useEffect(() => {
    // Небольшая задержка для корректной инициализации всех компонентов
    const timer = setTimeout(() => {
      setIsComponentReady(true);
    }, 200);
    
    return () => clearTimeout(timer);
  }, []);

  if (!isComponentReady) {
    return (
      <div className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">
            Мы решаем самые сложные задачи в области<br />
            <span className="highlight">поиска данных</span>
          </h1>
          <p className="hero-subtitle">
            <span className="brand">datacircle.ru</span> — команда экспертов и собственных AI-решений («AI-агенты»), занимающаяся сбором, обработкой, анализом и презентацией самых труднодоступных рыночных данных: от компенсационных пакетов, обычно не публикуемых в открытом доступе, до узкоспециализированных отраслевых метрик. Мы гарантируем «white glove» сервис, высокую точность и индивидуальный подход к каждому Клиенту.
          </p>
          <div className="hero-cta">
            <div className="buttons-container">
              {!user && (
                <div className="demo-button-container">
                  <Link to="/demo" className="hero-demo-button" id="heroDemoButton">Демо-версия</Link>
                  <div className="hero-demo-note" id="heroDemoNote">Попробуйте прямо сейчас</div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="dashboard-preview">
          <div className="dashboard-header">
            <div className="dashboard-title">Генеральный Директор</div>
            <div className="dashboard-categories">
              <div className="dashboard-category">
                <span className="category-label">Сектор</span>
                <span className="category-value blurred-value">Телекоммуникации</span>
              </div>
              <div className="dashboard-category">
                <span className="category-label">Сегмент</span>
                <span className="category-value blurred-value">Независимые инфраструктурные операторы</span>
              </div>
              <div className="dashboard-category">
                <span className="category-label">Тип выплаты</span>
                <span className="category-value">Постоянная компенсация (ежемесячная выплата)</span>
              </div>
            </div>
          </div>
          <div className="chart-container">
            <div style={{ 
              height: '100%', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              color: '#666',
              fontSize: '14px'
            }}>
              Загрузка...
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="hero-section">
      <div className="hero-content">
        <h1 className="hero-title">
          Мы решаем самые сложные задачи в области<br />
          <span className="highlight">поиска данных</span>
        </h1>
        <p className="hero-subtitle">
          <span className="brand">datacircle.ru</span> — команда экспертов и собственных AI-решений («AI-агенты»), занимающаяся сбором, обработкой, анализом и презентацией самых труднодоступных рыночных данных: от компенсационных пакетов, обычно не публикуемых в открытом доступе, до узкоспециализированных отраслевых метрик. Мы гарантируем «white glove» сервис, высокую точность и индивидуальный подход к каждому Клиенту.
        </p>
        <div className="hero-cta">
          <div className="buttons-container">
            {!user && (
              <div className="demo-button-container">
                <Link to="/demo" className="hero-demo-button" id="heroDemoButton">Демо-версия</Link>
                <div className="hero-demo-note" id="heroDemoNote">Попробуйте прямо сейчас</div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="dashboard-preview">
        <div className="dashboard-header">
          <div className="dashboard-title">Генеральный Директор</div>
          <div className="dashboard-categories">
            <div className="dashboard-category">
              <span className="category-label">Сектор</span>
              <span className="category-value blurred-value">Телекоммуникации</span>
            </div>
            <div className="dashboard-category">
              <span className="category-label">Сегмент</span>
              <span className="category-value blurred-value">Независимые инфраструктурные операторы</span>
            </div>
            <div className="dashboard-category">
              <span className="category-label">Тип выплаты</span>
              <span className="category-value">Постоянная компенсация (ежемесячная выплата)</span>
            </div>
          </div>
        </div>
        <div className="chart-container">
          <DashboardChart />
        </div>
      </div>
    </div>
  );
};

export default Hero;
